<template>
    <div class="full-discounted">
      <b-container fluid  >
        <div class="full-discounted-wrapper" v-if="!invalidDiscountCode">
          <h1>{{ $t("payment.methods.hotDeal.title") }}</h1>
          <h3>
            {{ $t("payment.methods.hotDeal.description") }}
          </h3>
          <img src="/images/hotDeal.svg" style="max-width:480px" :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"/>
        </div>
         <div class="full-discounted-wrapper" v-else>
          <h1 style="color:#CB0000 !important;">{{ $t("payment.methods.hotDeal.titleInvalidCode") }}</h1>
          <h3>
            {{ $t("payment.methods.hotDeal.descriptionInvalidCode") }}
          </h3>
          <img src="/images/reached.svg" style="max-width: 188px;" :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"/>
          <b-button class="success-button mt-3" @click="showPackageDialg()">{{$t('hotDeal.Choose another promotion')}}</b-button><br/>
           <p>
            {{ $t("payment.methods.hotDeal.or") }}
          </p>
           <a href="" style="color: var(--projectPrimaryColor);" @click="redirectUser(true)">{{$t('hotDeal.Free classified ads')}}</a><br/>
        </div>
      </b-container>
      <b-modal
						id="package-model"
						class="package-model"
						title="Preview Listing"
						size="xl"
						scrollable
						hide-footer
						hide-header
						ref="package-model"
						center
						no-close-on-backdrop
						no-close-on-esc
						>
						<div class="package-model">
              <Packages
                
                @childToParent="getSelectedPackages"
                :userPayment="arrUserPayment"
                :website="website"
                :showeHotDeals="false"
              />
              <div class="button-div">
                <b-button
                  id="paymentNewPackage"
                  @click="closePackageDialg()"
                  class=" cancel-button" style="border:0; width: 130px;margin-right: 25px;margin-top: 22px;height: 40px;"
                  >{{ $t('packagesscreen.cancel') }}</b-button
                >
                <b-button
                  id="paymentNewPackage"
                  @click="paymentNewPackage"
                  class="btn-submit-search"
                  :disabled="disabled"
                  >{{ $t('packagesscreen.buttontext') }}</b-button
                >
              </div>
						</div>
					</b-modal>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import * as actionType from "../../../controllers/ActionTypes";
import Packages from '@/components/packages/Packages';
export default {
  name: "hotDeal",
  components:{
    Packages
  },
  props: {
    orderId: {
      type: Number,
      required: true
    },
    formattedAmount: {
      type: String,
      required: true
    },
    hotDealDiscountCode: {
      type: Number,
      required: true,
    },
    paymentDiscountCode: {
      type: Number,
      required: false,
    },
    listingId: {
      type: Number,
      required: true,
    },
    changeLoading: {
      type: Function,
      required: true
    },
    previousPendingPaymentId: {
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    invalidDiscountCode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data(){
    return{
      packageDetailIds: [],
			urlWebsite: null,
			disabled: true,
			arrUserPayment : [],
			website: null,
      affiliate_dates_ids:'',
      loadingLoad: false,
    }
  },
  watch: {
    loading: function() {
      this.changeLoading(this.loading);
    },
    'packageDetailIds'(val){
			if(val.length){
				if(val.indexOf(10)>-1&&!this.urlWebsite){
					this.disabled=true;
				}else{
					this.disabled=false;
				}
			}else{
				this.disabled=true;
			}
		},
		urlWebsite(val){
			if (val.match('https://') || val.match('http://')) {
				this.disabled = false;
				return;
			} else {
				this.disabled = true;
			}
		}
	},
  methods: {
    ...mapActions("PaymentController", [actionType.PAY]),
    ...mapActions('PackageController', ['PAYMENT_NEW_PACKAGE']),
    processPayment() {
      this.loading = true;
      var vm = this;
      vm.PAY({
        user_payment_id: vm.orderId
      })
        .then(function(response) {
          vm.$router.push({
            name: "PaymentSuccess",
            params: {
              id: vm.orderId,
              previousPendingPaymentId: vm.previousPendingPaymentId
            }
          });
        })
        .catch(function(error) {
          vm.$router.push({
            name: "PaymentSuccess",
            params: {
              id: vm.orderId,
              previousPendingPaymentId: vm.previousPendingPaymentId
            }
          });
        });
    },
    redirectUser(success) {
      var vm = this;
      vm.$router.push({
        name: "PaymentSuccess",
        params: {
          success: success,
          id: vm.orderId,
          previousPendingPaymentId: vm.previousPendingPaymentId
        }
      });
    },
    showPackageDialg(){
       this.$bvModal.show('package-model');
    },
    closePackageDialg(){
       this.$bvModal.hide('package-model');
    },
    getSelectedPackages(ev) {
			console.log("ev",ev)
			let objectID = JSON.parse(JSON.stringify(ev));
			let arr = [];
			Object.values(ev.packagesValue).forEach(pack => {
				if (pack.packagesDetails) {
					arr.push(pack.packagesDetails.id);
				}
			});
			this.packageDetailIds = arr;
			this.urlWebsite = objectID.websiteUrl;
			let datesArr = [];
			ev.preBookedDates.forEach(date => {
				datesArr.push(date.id);
			});
			this.affiliate_dates_ids = datesArr;
			this.$forceUpdate();
		},
		paymentNewPackage() {
			this.loadingLoad = true;
			let obj={
				id: this.listingId,
				package_detail_ids: this.packageDetailIds,
			};
			if(this.website){
				obj.website=this.website;
			}
			if(this.affiliate_dates_ids){
				obj.affiliate_dates_ids=this.affiliate_dates_ids;
			}
			
			this.PAYMENT_NEW_PACKAGE(obj).then(result => {
				this.loadingLoad = false;
				this.$router.push(
          this.$i18nRoute({ name: 'payment' }) + result.data.data.id
          
        );
        this.closePackageDialg();
        location.reload();
			});
		}
  }
};
</script>
<style lang="scss" >
.button-div {
    flex-direction: row;
    box-sizing: border-box;
    display: flex;
    place-content: center;
    align-items: center;
    font-size: 16px;
    @media (max-width: 992px) {
        font-size: 18px;
    }

    .btn-submit-search {
        background: var(--projectPrimaryColor) !important;
        width: 130px;
        height: 40px;
        border: none;
        border-radius: var(--borderRadius);
        margin-right: 25px;
        margin-top: 22px;
        color:$white;
    }
}
.full-discounted-wrapper {
  padding-bottom: 20px;
  height: 100%;
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: center space-around;
  align-items: center;
  width: 100%;
  h1 {
    color: var(--projectPrimaryColor) !important;
    margin: 20px 0;
  }
  h3 {
    color: #444444;
  }
  .discounted-button {
    font-size: 16px;
    @media (max-width: 992px) {
      font-size: 18px;
    }
    width: 225px;
    background: var(--projectPrimaryColor) !important;
    color: $white;
    border-radius: var(--borderRadius);
    border: 1px solid var(--projectPrimaryColor) !important;
    height: 40px;
    margin: 20px 0;
    @media (max-width: 992px) {
      font-size: 18px;
    }
  }
  span {
    color: var(--projectPrimaryColor) !important;
    margin: 20px 0;
  }
}
</style>